import styled from 'styled-components'

export const TimerStyle = styled.div`
  color: red;

  .time-card {
    display: inline-block;
    border: solid 2px red;
    margin: 10px;
    padding: 10px;
  }
`
